import { useState, useEffect } from 'react';
import { config } from '@uhg-abyss/web/tools/config';
import { getUserPermissions } from '@sde/widgets-core/src/redux/resources/user/helpers';
import { useUser } from '@sde/widgets-core/src/redux/resources/user';
import { tokenizer } from '@uhg-abyss/web/tools/tokenizer';
import { getAppPermissions } from '@src/common/NavMenuLink/permissionsFunctions';
import { getFeature } from '@sde/widgets-core/src/redux/tools/features';
import { usePPDLagoon } from '@sde/widgets-core/src/tools/lagoon';

export const useAppNav = () => {
  const { user } = useUser.state();
  const [appPermissions, setAppPermissions] = useState({});
  const { getHeaderContents } = usePPDLagoon();

  user.username =
    user.username && user.username.includes('?')
      ? user.username.replaceAll('?', '-question-')
      : user.username;

  user.optumId =
    user.optumId && user.optumId.includes('?')
      ? user.optumId.replaceAll('?', '-question-')
      : user.optumId;

  const priorAuthParams = tokenizer.create({
    sso: 'paan',
    ...user,
  });
  const params = { priorAuthParams };

  useEffect(() => {
    setAppPermissions(getUserPermissions(user));
  }, [user.permissions]);
  const navMenu = getHeaderContents('navMenu');
  const getExitLinkParams = (navItem) => {
    const { exitLink, modalContent, buttonContent, paramKey } = navItem;
    if (exitLink && !getFeature(navItem.isInternal || navItem.redirectToggle)) {
      let exitLinkUrl = config(exitLink);

      if (exitLink === 'UHC_SSO_URL') {
        const BASE_URL = window.location.href.replace(/\/#.*/, '');
        exitLinkUrl = `${BASE_URL}/#/sso`;
      }

      if (!exitLinkUrl) {
        exitLinkUrl = exitLink;
      }

      if (paramKey) {
        exitLinkUrl = `${exitLinkUrl}/${params[paramKey]}`;
      }

      return {
        modalContent,
        buttonContent,
        paramKey,
        to: exitLinkUrl,
      };
    }

    return null;
  };

  const blockIfUserNotPermitted = (navItem) => {
    const { isBlocked, permission } = navItem;
    if (isBlocked) return true;
    const hasPermission = getAppPermissions(permission, appPermissions);
    return !hasPermission;
  };

  return navMenu
    .map((navItem) => {
      const exitLinkParams = getExitLinkParams(navItem);
      const appNavItemInputs = {
        ...navItem,
        exitLink: exitLinkParams,
        isBlocked: blockIfUserNotPermitted(navItem),
      };
      if (
        navItem.statusToggles &&
        !navItem.statusToggles.split(',').some((toggle) => getFeature(toggle))
      )
        return null;
      return appNavItemInputs;
    })
    .filter(Boolean);
};
